<template>
  <div class="main">
    <!-- <component :is="childComponent"></component> -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'UserInfo',
  data() {
    return {
      childComponent: 'EditUser'
    };
  },
  components: {},
  created: function () {
    this.getParams();
  },
  methods: {
    getParams() {
      // 取到路由带过来的参数
      const routerParams = this.$route.params.op;

      // 将数据放在当前组件的数据内
      if (routerParams == 'u') {
        this.childComponent = 'EditingUser';
      } else {
        this.childComponent = 'EditUser';
      }
    }
  },
  watch: {
    //'$route': 'getParams'
    $route(to, from) {
      // 对路由变化作出响应...
      if (to.params != from.params) {
        this.getParams();
      }
    }
  }
};
</script>

<style scoped>
.main {
  width: 100%;
  height: calc(100% - 120px);
  overflow: auto;
}
.invite-content {
  background-color: #c6cbd1;
  border-radius: 8px;
  display: flex;
  flex-flow: column;
}
/* @media (max-width: 1240px) {
  .main {
    width: 100%;
    height: calc(100% - 120px);
    overflow: auto;
  }
} */
</style>
